import { FC } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import ButtonBase from 'src/components/Button';
import { MobileModalType, ModalFooter, ModalContent, ModalHeader, ModalHeaderTitle } from 'src/components/ModalLayout';
import { useRestMutation } from 'src/hooks/useRestMutation';
import { ConsentApiList } from 'src/stores/auth/apis';
import { userDataAtom } from 'src/stores/auth/atoms';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { showCommonErrorToastAtom } from 'src/stores/toast/atoms';
import { ConsentInfo } from 'src/types/AzarUser';
import { ConsentsMapRequest } from 'src/types/consent';
import { ModalType } from 'src/types/Modal';
import { MakeRequired } from 'src/types/utils';
import { Desc, ModalLayout } from './style';
const Button = styled(ButtonBase)``;
const Disagree = styled(ButtonBase)`
  font-weight: 600;
  margin-bottom: 16px;
`;
interface Props {
  consent: MakeRequired<ConsentInfo, 'consentRevisionPopup'>;
}
const UpdatedTosApprovalModal: FC<Props> = ({
  consent
}) => {
  const closeModal = useSetAtom(closeModalAtom);
  const setUserData = useSetAtom(userDataAtom);
  const showCommonErrorToast = useSetAtom(showCommonErrorToastAtom);
  const {
    mutate,
    isPending
  } = useRestMutation<ConsentsMapRequest>({
    path: ConsentApiList.ReportConsent,
    method: 'post',
    options: {
      onSuccess: () => {
        closeModal(ModalType.TOS_RE_APPROVAL);
        setUserData(prev => {
          if (!prev) return prev;
          return {
            ...prev,
            consentsRequired: prev.consentsRequired?.filter(requiredConsent => requiredConsent.consentId !== consent.consentId)
          };
        });
      },
      onError: () => {
        showCommonErrorToast();
      }
    }
  });
  const handleAccept = () => {
    mutate({
      consents: {
        [consent.type]: consent.consentId
      }
    });
  };
  return <ModalLayout isDim closeWhenClickOutside={false} mobileType={MobileModalType.BOTTOM_SHEET} data-testid='Updated-Consent-Modal' data-test-modal-id={consent.consentId} data-sentry-element="ModalLayout" data-sentry-component="UpdatedTosApprovalModal" data-sentry-source-file="UpdatedTosApprovalModal.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="UpdatedTosApprovalModal.tsx">
        <ModalHeaderTitle mobileType={MobileModalType.BOTTOM_SHEET} data-sentry-element="ModalHeaderTitle" data-sentry-source-file="UpdatedTosApprovalModal.tsx">
          {consent.consentRevisionPopup.title}
        </ModalHeaderTitle>
      </ModalHeader>
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="UpdatedTosApprovalModal.tsx">
        <Desc dangerouslySetInnerHTML={{
        __html: consent.consentRevisionPopup.content
      }} data-sentry-element="Desc" data-sentry-source-file="UpdatedTosApprovalModal.tsx" />
      </ModalContent>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="UpdatedTosApprovalModal.tsx">
        <Disagree id='TOS_DISAGREE' variant='outlined' onClick={() => window.open(consent.url, '_blank')} data-sentry-element="Disagree" data-sentry-source-file="UpdatedTosApprovalModal.tsx">
          {consent.consentRevisionPopup.linkLabel}
        </Disagree>
        <Button data-testid='Confirm-Button' onClick={handleAccept} id='TOS_AGREE' disabled={isPending} data-sentry-element="Button" data-sentry-source-file="UpdatedTosApprovalModal.tsx">
          {consent.consentRevisionPopup.buttonLabel}
        </Button>
      </ModalFooter>
    </ModalLayout>;
};
export default UpdatedTosApprovalModal;